import React, { createContext, useContext, useState, ReactNode } from 'react'
import { IRiderObject } from 'src/types'

export interface RiderInfoContextType {
  riderInfo: IRiderObject | null
  setRiderInfo: (profile: IRiderObject | null) => void
}

const RiderContext = createContext<RiderInfoContextType | undefined>(undefined)

export const RiderInfoProvider = ({ children }: { children: ReactNode }) => {
  const [riderInfo, setRiderInfo] = useState<IRiderObject | null>(null)
  return <RiderContext.Provider value={{ riderInfo, setRiderInfo }}>{children}</RiderContext.Provider>
}

export const useRiderInfo = (): RiderInfoContextType => {
  const context = useContext(RiderContext)
  if (!context) {
    throw new Error('useRiderInfo must be used within a RiderInfoProvider')
  }
  return context
}



// WEBPACK FOOTER //
// ./src/components/trips/rider-info/RiderInfoContext.tsx